














import { Component, Vue, Prop } from "vue-property-decorator";
import axios from 'axios';

import VoteItem from './VoteItem.vue';
import { Item, Vote } from '../types';
import VoteService from '../vote-service';
import AdSegmentationService from '../ad-segmentation-service';

@Component({
components: {
VoteItem
}
})
export default class App extends Vue {
@Prop() apiUrl!: string;
@Prop() adSegmentationUrl!: string;
@Prop() adSegmentationApiKey!: string;
@Prop() id!: string;
@Prop() cookieDomain!: string;

private items: Item[] = [];

private voteService: VoteService = new VoteService(this.apiUrl, this.cookieDomain);
private adSegmentService: AdSegmentationService = new AdSegmentationService(this.adSegmentationUrl, this.adSegmentationApiKey, this.cookieDomain);

private vote!: Vote;
private selectedId: string = '';
private showResult: boolean = false;
private isLoaded: boolean = false;

mounted() {
//  this.voteService = new VoteService(this.apiUrl, this.cookieDomain);
this.loadData();
}

async loadData() {
var result = await this.voteService.load(this.id);

this.items = result.items;
this.vote = result.vote;

this.showResult = this.voteService.isAlreadyVotedFor(this.id);
this.isLoaded = true;
}

public async castVote() {
if (this.vote) {
this.items = await this.voteService.save(this.vote.id, this.selectedId);

try{
var selectedItem = this.items.find(item => item.id === this.selectedId);
if (selectedItem && selectedItem.isSegment && selectedItem.segmentId !== null && selectedItem.segmentId !== '') {
        this.adSegmentService.send(selectedItem.segmentId);
      }
    }
    catch (err) { 
      console.log(err);
    }

    this.showResult = true;
    
  }
}
}
